export const desktopActionChime = [
  { frequency: 659.25, offset: 0, duration: 0.16 },
  { frequency: 880, offset: 0.18, duration: 0.24 },
] as const;

let sharedAudioContext: AudioContext | null = null;

export function scheduleDesktopActionChime(context: AudioContext) {
  const startAt = context.currentTime + 0.02;
  for (const note of desktopActionChime) {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const noteStart = startAt + note.offset;
    const noteEnd = noteStart + note.duration;
    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(note.frequency, noteStart);
    gain.gain.setValueAtTime(0.0001, noteStart);
    gain.gain.exponentialRampToValueAtTime(0.16, noteStart + 0.025);
    gain.gain.exponentialRampToValueAtTime(0.0001, noteEnd);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(noteStart);
    oscillator.stop(noteEnd);
  }
}

export async function playDesktopActionChime() {
  if (typeof window === "undefined") return false;
  const AudioContextConstructor =
    window.AudioContext ??
    (window as Window & { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext;
  if (!AudioContextConstructor) return false;
  try {
    if (!sharedAudioContext || sharedAudioContext.state === "closed")
      sharedAudioContext = new AudioContextConstructor();
    if (sharedAudioContext.state === "suspended")
      await sharedAudioContext.resume();
    scheduleDesktopActionChime(sharedAudioContext);
    return true;
  } catch {
    return false;
  }
}
